<script setup lang="ts">
import type { Alert } from '@convatec/180medical-website/types/app'
import { useAppSettingsStore } from '@convatec/180medical-website/app/stores/app-settings'

const appSettingsStore = useAppSettingsStore()
const { alerts } = storeToRefs(appSettingsStore)

function dismissAlert(alert: Alert) {
  appSettingsStore.dismissAlert(alert)
}
</script>

<template>
  <div :class="{ 'h-0 overflow-hidden': alerts.length === 0 }">
    <AlertBlock
      v-for="alert in alerts"
      :key="alert.key"
      :variant="alert.variant || 'info'"
      :message="alert.text"
      :link="alert.link"
      @dismiss="dismissAlert(alert)"
    />
  </div>
</template>
